// UserContext.tsx
import { createContext, useContext, useEffect, useState } from 'react';
import firebase from 'firebase/compat/app';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { app } from '../firebase';

interface IUser {
  email: string | null;
  uid: string | null;
}

interface IUserContext {
  user: IUser;
  loading: boolean;
  logout: () => void;
}

const initialUser: IUser = {
  email: null,
  uid: null,
};

const UserContext = createContext<IUserContext>({
  user: initialUser,
  loading: true,
  logout: () => { },
});

export const useUser = () => useContext(UserContext);

export const UserProvider= ({children}: {children: React.ReactNode}) =>{
  const [user, setUser] = useState<IUser>(initialUser);
  const [loading, setLoading] = useState(true);

  const initializeUser = () => {
    setLoading(true);
    const auth = firebase.auth(app);
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setLoading(false);
      if (user) {
        setUser({
          email: user.email,
          uid: user.uid,
        });
      } else {
        setUser(initialUser);
      }
    });

    return unsubscribe;
  };

  const logout = () => {
    signOut(firebase.auth(app))
      .then(() => {
        setUser(initialUser);
      })
      .catch((error) => {
        console.error('Error while logging out:', error);
      });
  };

  useEffect(() => {
    const unsubscribe = initializeUser();
    return () => unsubscribe();
  }, []);

  return <UserContext.Provider value={{ user, loading, logout }}>{children}</UserContext.Provider>;
};
